document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('#menu-drawer [data-menu-trigger]').forEach(menu => {
        menu.addEventListener('click', () => {
            const menuList = menu.querySelector('.menu_list')
            menuList.classList.add('submenu_drawer');
            const collapsible_titles = menuList.querySelectorAll('.submenu_drawer .collapsible_tab_title')
            collapsible_titles.forEach(title => {
                title.addEventListener('click', (e) => {
                    e.stopImmediatePropagation()
                    title.classList.toggle('active');
                })
            })
            const backToMainMenu = menuList.querySelector('.back_to_main_menu');
            backToMainMenu.addEventListener('click', (e) => {
                e.stopPropagation()
                backToMainMenu.closest('.menu_list').classList.remove('submenu_drawer')
            })
        })
    })
})